import React from "react";
import axios from 'axios';

import { store } from "../../redux/store";
import { connect } from "react-redux";
import Header from "../HeaderComponent/Header";
import history from "../../auth/history";
import './Subtransaction.css';
import './MoneyTransfer.css';
import FooterComponet from "../FooterComponent/FooterComponet";
import SubTransactionDetails from "./SubTransactionDetails";
import OrderDetails from "./OrderDetails";
import TransferDetails from "./TransferDetails";
import AccountReview from "./AccountReview";
import $ from "jquery";
import moment, { max } from "moment";
import { v4 as uuidv4 } from 'uuid';

import { setMoneyTransferResponse } from './../../redux/response/response.action';
import { selectedSender, setMoneyTransferProgress, setTxnAmount, setTxnsurcharge, setTxntotalAmount, setStatusEnqResponse } from './../../redux/misc-data/misc-data.action';
import ProgressGif from '../../assests/images/progress.gif';
import ProgressStatic from '../../assests/images/progress.jpg';
import MtFailed from '../../assests/images/mtfailed.png';
import MtSuccess from '../../assests/images/mtsuccess.png';
import MtPartial from '../../assests/images/mtpartial.png';
import BankLogo from "../../assests/images/bank-logo.png";
import Avatar from 'react-avatar';
import HeaderCommon from './../HeaderComponent/HeadeCommon';
import Menu from "../MenuComponent/Menu";
import { Link } from "react-router-dom";
import tokenErrorHandler from "../tokenErrorHandler";
const httpClient = axios.create();

class MoneyTransferDetails1 extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			phoneNo: this.props.phone,
			moneyTransferFinalStatusCompleted: false,
			finalTransferMessage: ''
		}
	}


	componentDidMount() {

		store.dispatch(setTxnAmount(''));
		store.dispatch(setTxnsurcharge(''));
		store.dispatch(setTxntotalAmount(''));


		store.dispatch(setMoneyTransferProgress(''));
		store.dispatch(setStatusEnqResponse(''));
		var counter = 0;
		var statusEnqInterval = '';
		this.statusEnquiry();

		statusEnqInterval = setInterval(() => {


			counter++;
			console.log('counter value...' + counter);

			if (counter <= 11) {
				//store.dispatch(setMoneyTransferProgress('gap'));

				this.statusEnquiry(statusEnqInterval);
			} else {
				// alert(counter);
				console.log('clearing interval after 1 minute');
				clearInterval(statusEnqInterval);
				store.dispatch(setMoneyTransferProgress('statusEnquirycompletedInpendingStatus'));
			}
		}, 5000);
	}


	statusEnquiry = (statusEnqInterval) => {
		console.log(this.props.moneyTransferProgress)

		if ((
			this.props.moneyTransferProgress == '')) {
			this.setState({
				progess: 'start'
			});

			store.dispatch(setMoneyTransferProgress('start'));

			var enquiryUrl = '/api/v1/dmt/order/enquiry/order-id/'
				+'12345'
				;

			const headers = {
				'Authorization': 'Bearer ' + this.props.token,
				'client-id': this.props.agentInfo.id,
				'role': "ROLE_EMITRA_CSP"
			}

			httpClient.get(enquiryUrl, {
				timeout: 60 * 1000,
				timeoutErrorMessage: 'timeout',
				headers
			}
			).then((response) => {



				console.log('enquiry response' + JSON.stringify(response.data));
				if (response.data.response.success == true) {
					console.log('enquiry service success response:' + JSON.stringify(response.data));
					store.dispatch(setStatusEnqResponse(response.data));

					var txnAmount = 0;
					var surcharge = 0;
					var subOrderStatusList = [];
					response.data.subOrders.map(suborder => {

						if (suborder.status == 'SUCCESS') {
							txnAmount = txnAmount + parseInt(suborder.txnDetails.amount);
							surcharge = surcharge + parseInt(suborder.txnDetails.surcharge);

							var totalTxnAmount = txnAmount + surcharge;
							store.dispatch(setTxnAmount(txnAmount));
							store.dispatch(setTxnsurcharge(surcharge));
							store.dispatch(setTxntotalAmount(totalTxnAmount));
							// alert(totalTxnAmount);

						}

						subOrderStatusList.push(suborder.status.toUpperCase());
						console.log('suorder satus::' + subOrderStatusList);


					})
					if (subOrderStatusList.includes("INIT")) {
						this.setState({
							progess: 'pending'
						})
						store.dispatch(setMoneyTransferProgress('pending'));


					} else if (subOrderStatusList.includes("SUBMITTED")) {
						this.setState({
							progess: 'pending'
						})
						store.dispatch(setMoneyTransferProgress('pending'));

					} else if (subOrderStatusList.includes("REVERSED")) {
						this.setState({
							progess: 'failed'
						})
						store.dispatch(setMoneyTransferProgress('failed'));
					}
					else if (subOrderStatusList.includes("SUCCESS") && !subOrderStatusList.includes("FAIL")) {
						console.log('all suborder success');
						this.setState({
							progess: 'finished'
						})
						store.dispatch(setMoneyTransferProgress('finished'));
					} else if (!subOrderStatusList.includes("SUCCESS") && subOrderStatusList.includes("FAIL")) {
						console.log('all suborder failed');
						this.setState({
							progess: 'failed'
						})
						store.dispatch(setMoneyTransferProgress('failed'));
					} else if (subOrderStatusList.includes("SUCCESS") && subOrderStatusList.includes("FAIL")) {
						console.log('partial success');
						this.setState({
							progess: 'partial success'
						})
						store.dispatch(setMoneyTransferProgress('partial success'));
					} else {
						this.setState({
							progess: 'pending'
						})
						store.dispatch(setMoneyTransferProgress('pending'));
					}

				} else if (response.data.response.success == false) {
					console.log('enquiry service failed response :' + JSON.stringify(response.data));
					store.dispatch(setStatusEnqResponse(response.data));
					this.setState({
						progess: 'failed'
					})
					store.dispatch(setMoneyTransferProgress('failed'));

				} else {
					store.dispatch(setStatusEnqResponse(response.data));
					console.log('enquiry service other response :' + JSON.stringify(response.data))
					this.setState({
						progess: 'pending'
					})

					store.dispatch(setMoneyTransferProgress('pending'));
				}
				//
			}).catch(error => {
				this.setState({
					progess: 'pending'
				})
				store.dispatch(setMoneyTransferProgress('pending'));
				if(error.message.includes("401")){
					tokenErrorHandler.tokenErrorHandle(error.message,this.props.callBackUrl)
				}else{
					
				}
				console.log('enquiry response error::' + error);
			})
		} else {
			console.log('clearing interval as response status is:' + this.props.moneyTransferProgress);
			clearInterval(statusEnqInterval);
		}
	}

	componentWillUnmount() {
	}


	print = (event) => {
		event.preventDefault();
		window.print();
	}


	render() {


		return (

			<div>
                {"Progresss.........."+this.props.moneyTransferProgress}
            </div>

		);
	}
}


const mapStateToProps = (
	{ errorMessageReduce: { errorMessage, loginErrorMessage },
		miscReduce: { phone, moneyTransferResponseDetails,
			createOrderResponseDetails, agentInfo, token,
			selectSender, benefisciaryInfo,
			createOrderRes, transferTotalAmount, surcharge,

			txmAmnt,
			txnSurchrg,
			txnTotalAmnt,
			moneyTransferProgress,
			createOrderStatusResponse,
			bankLogoListTxt,
			callBackUrl
		}
	}
) => ({
	errorMessage, loginErrorMessage, phone, moneyTransferResponseDetails,
	createOrderResponseDetails, agentInfo, token, selectSender,
	benefisciaryInfo,
	createOrderRes, transferTotalAmount, surcharge,

	txmAmnt,
	txnSurchrg,
	txnTotalAmnt,
	moneyTransferProgress,
	createOrderStatusResponse,
	bankLogoListTxt,
	callBackUrl
});

export default connect(mapStateToProps, null)(MoneyTransferDetails1);
